import { BoobleModalService } from 'booble-modal';
import { Component } from "@angular/core";

@Component({
    templateUrl: './use-terms-modal.component.html',
    styleUrls: ['./use-terms-modal.component.scss']
})
export class UseTermsModal {

    constructor(private modalService: BoobleModalService) { }

    closeModal() {
        this.modalService.dismiss(null);
    }

}